var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { useUniqID } from './useUniqId';
export var buildUseOnlyOneInstanceOpened = function () {
    var instances = [];
    var InstanceContext = React.createContext({
        parentIds: [],
        close: function () { },
    });
    var useInstanceContext = function () { return React.useContext(InstanceContext); };
    var useOnlyOneInstanceOpened = function (inputInstanceStatus) {
        var instanceId = useUniqID();
        var parentIds = useInstanceContext().parentIds;
        var instanceStatus = __assign(__assign({}, inputInstanceStatus), { id: instanceId });
        var instanceStatusRef = React.useRef(instanceStatus);
        instanceStatusRef.current = instanceStatus;
        React.useEffect(function () {
            instances.push(instanceStatusRef);
            return function () {
                instances = instances.filter(function (i) { return i !== instanceStatusRef; });
            };
        }, []);
        React.useEffect(function () {
            if (instanceStatus.open) {
                instances.forEach(function (instanceToClose) {
                    if (instanceToClose !== instanceStatusRef &&
                        !parentIds.includes(instanceToClose.current.id) &&
                        instanceToClose.current.open) {
                        instanceToClose.current.onClose();
                    }
                });
            }
        }, [instanceStatus.open]); // eslint-disable-line react-hooks/exhaustive-deps
        return instanceId;
    };
    var InstanceProvider = function (_a) {
        var id = _a.id, onClose = _a.onClose, children = _a.children;
        var parentIds = useInstanceContext().parentIds;
        var contextValue = React.useMemo(function () { return ({ parentIds: __spreadArray(__spreadArray([], parentIds, true), [id], false), close: onClose }); }, [id, onClose, parentIds]);
        return (React.createElement(InstanceContext.Provider, { value: contextValue }, children));
    };
    return { useOnlyOneInstanceOpened: useOnlyOneInstanceOpened, useInstanceContext: useInstanceContext, InstanceProvider: InstanceProvider };
};
//# sourceMappingURL=buildUseOnlyOneInstanceOpened.js.map